import { Component, OnInit } from '@angular/core';
import pizzamenu from '../../../../data/pizzamenu.json';
import platmenu from '../../../../data/platmenu.json';
import MankloubAndSandwitchamenu from '../../../../data/makloubAndSandwitchMenu.json'
import burgerMenu from '../../../../data/burgermenu.json'
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  constructor() { }
  public pizzamenu: { id: number }[] = pizzamenu;
  public platmenu: { id: number }[] = platmenu;
  public MankloubAndSandwitchamenu: { id: number }[] = MankloubAndSandwitchamenu;
  public burgerMenu: { id: number} [] = burgerMenu;


  ngOnInit(): void {
  }

}
